import EscalationService from 'src/modules/escalation/escalationService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'ESCALATION_VIEW';

const escalationViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: escalationViewActions.FIND_STARTED,
      });

      const record = await EscalationService.find(id);

      dispatch({
        type: escalationViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: escalationViewActions.FIND_ERROR,
      });

      getHistory().push('/escalation');
    }
  },
};

export default escalationViewActions;
